// Kontots sidor (ADR 0062). Allt utom inloggningen, Skapa konto (ADR 0106) och
// avtalen kräver att man är inloggad.
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState, type ReactNode } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router';
import { AuthProvider, type AuthProviderProps } from './auth/auth.js';
import { KraverInloggning } from './layout/KraverInloggning.js';
import { Shell } from './layout/Shell.js';
import { Forfragan } from './pages/Forfragan.js';
import { AnvandareSida } from './pages/Anvandare.js';
import { Formular } from './pages/Formular.js';
import { Inkorg } from './pages/Inkorg.js';
import { Katalog } from './pages/katalog/Katalog.js';
import { Regler } from './pages/katalog/Regler.js';
import { Tjanster } from './pages/katalog/Tjanster.js';
import { Versioner } from './pages/katalog/Versioner.js';
import { Villkor } from './pages/katalog/Villkor.js';
import { KomIgang } from './pages/KomIgang.js';
import { AvtalSida } from './pages/avtal/AvtalSida.js';
import { LoggaIn } from './pages/inloggning/LoggaIn.js';
import { SkapaKonto } from './pages/inloggning/SkapaKonto.js';
import { Offertmall } from './pages/Offertmall.js';
import { Abonnemang } from './pages/Abonnemang.js';
import { Resurser } from './pages/Resurser.js';
import { SidanFinnsInte } from './pages/SidanFinnsInte.js';
import { Testlage } from './pages/Testlage.js';
import { Uppfoljning } from './pages/Uppfoljning.js';
import { UppfoljningPost } from './pages/UppfoljningPost.js';
import { Utskick } from './pages/Utskick.js';
import { BetalningKlar } from './pages/betalning/BetalningKlar.js';
import { ValjPlan } from './pages/betalning/ValjPlan.js';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/logga-in" element={<LoggaIn />} />
      <Route path="/skapa-konto" element={<SkapaKonto />} />
      <Route path="/villkor" element={<AvtalSida sort="terms" />} />
      <Route path="/bitradesavtal" element={<AvtalSida sort="dpa" />} />
      <Route
        path="/kom-igang"
        element={
          <KraverInloggning>
            <KomIgang />
          </KraverInloggning>
        }
      />
      <Route
        path="/valj-plan"
        element={
          <KraverInloggning>
            <ValjPlan />
          </KraverInloggning>
        }
      />
      <Route
        path="/valj-plan/klar"
        element={
          <KraverInloggning>
            <BetalningKlar />
          </KraverInloggning>
        }
      />
      <Route
        element={
          <KraverInloggning>
            <Shell />
          </KraverInloggning>
        }
      >
        <Route index element={<Inkorg />} />
        <Route path="forfragningar/:id" element={<Forfragan />} />
        <Route path="katalog" element={<Katalog />}>
          <Route index element={<Tjanster />} />
          <Route path="regler" element={<Regler />} />
          <Route path="villkor" element={<Villkor />} />
          <Route path="versioner" element={<Versioner />} />
        </Route>
        <Route path="testlage" element={<Testlage />} />
        <Route path="offertmall" element={<Offertmall />} />
        <Route path="utskick" element={<Utskick />} />
        <Route path="uppfoljning" element={<Uppfoljning />} />
        <Route path="uppfoljning/:id" element={<UppfoljningPost />} />
        <Route path="formular" element={<Formular />} />
        <Route path="anvandare" element={<AnvandareSida />} />
        <Route path="abonnemang" element={<Abonnemang />} />
        <Route path="resurser" element={<Resurser />} />
        <Route path="*" element={<SidanFinnsInte />} />
      </Route>
    </Routes>
  );
}

export function Providers({
  children,
  ...auth
}: Omit<AuthProviderProps, 'children'> & { children: ReactNode }) {
  const [queryClient] = useState(
    () => new QueryClient({ defaultOptions: { queries: { staleTime: 30_000 } } }),
  );
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider {...auth}>{children}</AuthProvider>
    </QueryClientProvider>
  );
}

export function App() {
  return (
    <Providers {...(import.meta.env.VITE_API_URL ? { baseUrl: import.meta.env.VITE_API_URL } : {})}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </Providers>
  );
}
